import { render, staticRenderFns } from "./DetalheCoberturaVendedor.vue?vue&type=template&id=6fdd5ce0&scoped=true&"
import script from "./DetalheCoberturaVendedor.vue?vue&type=script&lang=js&"
export * from "./DetalheCoberturaVendedor.vue?vue&type=script&lang=js&"
import style0 from "./DetalheCoberturaVendedor.vue?vue&type=style&index=0&id=6fdd5ce0&scoped=true&lang=css&"
import style1 from "./DetalheCoberturaVendedor.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdd5ce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VContainer,VDivider,VIcon,VRow,VSelect,VTooltip})
